// 警報處理歷程（EVT-06 / EVT-07）：狀態變更、指派 / 取消指派、只加備註、逾時通知（舊的在上）。事件詳細與警報工作台共用。
import { useTranslation } from 'react-i18next';
import type { AlarmChange } from '../lib/alarms';
import { stamp } from '../lib/timefmt';

/** 歷程：狀態變更、指派 / 取消指派、只加備註、逾時通知（舊的在上）。 */
export function AlarmHistoryList({ history, tz, me }: { history: AlarmChange[]; tz?: string; me: string }) {
  const { t } = useTranslation();
  const who = (id: string, name?: string) => (id === me ? t('wb.me') : name || (id ? t('wb.left_member') : t('wb.system')));
  return (
    <ol className="alarm-history small" data-alarm-history>
      {history.map((h, i) => {
        const kind = h.kind ?? 'state';
        let body: string;
        switch (kind) {
          case 'assign':
            body = t('wb.h_assign', { by: who(h.by, h.by_name), to: who(h.assignee ?? '', h.assignee_name) });
            break;
          case 'unassign':
            body = t('wb.h_unassign', { by: who(h.by, h.by_name), to: who(h.assignee ?? '', h.assignee_name) });
            break;
          case 'note':
            body = t('wb.h_note', { by: who(h.by, h.by_name) });
            break;
          case 'overdue':
            body = h.merged_into
              ? t('wb.h_overdue_merged', { at: stamp(h.merged_into, { tz }) })
              : h.notified?.length
                ? t('wb.h_overdue', { list: h.notified.map((n) => who(n.user_id, n.name)).join(t('common.list_sep')) })
                : t('wb.h_overdue_none');
            break;
          default:
            body = `${who(h.by, h.by_name)} · ${t(`alarm.state_${h.from}`)} → ${t(`alarm.state_${h.to}`)}`;
            if (h.cleared_assignee) body += ' ' + t('wb.h_cleared', { name: who(h.cleared_assignee, h.cleared_assignee_name) });
        }
        return (
          <li key={i} data-alarm-history-to={h.to} data-alarm-history-kind={kind}>
            {stamp(h.at, { tz })} · {body}
            {h.note ? <span className="muted">（{h.note}）</span> : null}
          </li>
        );
      })}
    </ol>
  );
}

